(function() {
    'use strict';
 
 
a3_pilot_reports.factory('PilotReportLocalEditFactory',PilotReportLocalEditFactory);
  
    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name PilotReportLocalEditFactory
    * @description 
    *   Manage Local Pilot Reports.
    * @ngInject
    */
function PilotReportLocalEditFactory($log,localStorageMD5Service,GenericService, GroundServicesFactory){

        /**
         * Initialiaze PilotReportLocalEdit object 
         * @memberof PilotReportLocalEditFactory
         */
    function PilotReportLocalEdit() {
		this.ReportGuid = null;
		this.AuthorId = null;
		this.AuthorAimsId = null;
		this.AuthorName = null;
		this.Created = null;
		this.FlightAimsId = null;
        this.FlightId=null;
		this.LastUpdated = null;
		this.Departure = null;
		this.Arrival = null;
		this.AcType = null;
		this.AcTailNo = null;
		this.FlightDate = null;
		this.FlightNo = null;
		this.ScheduledDeparture = null;
		this.ScheduledDepartureDateUTC = null;
		this.ScheduledDepartureTimeUTC = null;
		this.Departure = null;
		this.Arrival = null;
		this.ReportId = null;
		this.NothingToReport = null;
		this.Status = null; // pending, draft, completed, synched
		this.Sections = [];
		this.ActiveItems = 0;
		this.WarningItems = 0;
		this.IsValid = false;
		//v1.1 added pax and dep/arr details
		this.BookedC = null;
		this.BookedY = null;
		this.BookedInf = null;
		this.BookedPad = null;
		this.BookedChld = null;
		this.ActualC = null;
		this.ActualY = null;
		this.ActualInf = null;
		this.ActualPad = null;
		this.ActualChld = null;
		this.DepartureICAO = null;
		this.DepartureCountry = null;
		this.DepartureName = null;
		this.ArrivalICAO = null;
		this.ArrivalCountry = null;
		this.ArrivalName = null;
		this.crew = null;
        this.AutolandSatisfactory = false;
        this.AutolandUnsatisfactory = false;
		this.AutolandWorkOrderNo = null;
		this.AutolandWorkOrderNoIsValid = null;
        this.catApproachUnsatisfactory = false;
		this.catApproachSatisfactory = false;
		this.AutolandReasonIsPractice = false;
		this.AutolandReasonIsLowVisibility = false;
		this.ManualLanding = false;
		this.ManualLandingComments = null;

		this.GroundServicesSectionHasValue = false;	
		this.ArrivalGroundServices = [];
		this.DepartureGroundServices = [];
    
		this.ACUProvision = {
			isRequired: false, 
			hasValue: false, 
			isValid: false,
			values: {
				Yes: false,
				No: false,
				Delayed: false,
				NotRequired: false,
				Faulty: false
			}, 
			value: null,
			remarks: null,
			delayMinutes: null
		};
								
		//new fields 
		this.DepartureGate=null;
		this.DepartureTimezone=null;
		this.ArrivalTimezone=null;
		this.CallSign=null;
		this.ScheduledArrival=null;
		
		this.getDescription = getDescription;
		this.getRoute = getRoute;
		this.updateTotals = updateTotals;
		this.saveReport = saveReport;
		this.saveReportAsTemp = saveReportAsTemp;				
	}

     var objType = 'pilotReportLocalEdits';
     var objCallback = PilotReportLocalEdit; 

    var service = {
                fromObject : fromObject,
                fromObjectList:fromObjectList,
                getPilotReportsFromStorage:getPilotReportsFromStorage,
                setPilotReportsToStorage:setPilotReportsToStorage,
                deleteTempReport:deleteTempReport,
                deleteReport:deleteReport,
                getPilotReportLocalEditFromTemp:getPilotReportLocalEditFromTemp,
                getPilotReportLocalEditForFlight:getPilotReportLocalEditForFlight,
                getPilotReportLocalEdit:getPilotReportLocalEdit,
                getPilotReportLocalEditCountThatNeedToBeSynched:getPilotReportLocalEditCountThatNeedToBeSynched,
                getPilotReportLocalEditThatNeedToBeSynched:getPilotReportLocalEditThatNeedToBeSynched,
                getNewReport:getNewReport,
                markReportAsSynched:markReportAsSynched,
				setPilotReportToStorage:setPilotReportToStorage,
				checkForNewGroundServices: checkForNewGroundServices,
				getFlightIdsWithPendingReports: getFlightIdsWithPendingReports
     }                                                     

        /**
         * Get a short Description of this Pilot report
         * @memberof PilotReportLocalEditFactory
         * @returns {string} Description 
         */
		function getDescription() {
			var s = this.FlightNo + ' ' + this.Departure + '-' + this.Arrival + ' ' + this.ScheduledDepartureDateUTC + ' by ' + this.AuthorName;
			return s;
		}
    
        /**
         * Get the Route of this Pilot report
         * @memberof PilotReportLocalEditFactory
         * @returns {string} Route 
         */
		function getRoute() {
			if (this.Departure == null && this.Arrival == null) return '-';
			else return (this.Departure || '?') + '-' + (this.Arrival || '?');
		}
    
        /**
         * Update the totals of all the section of the report
         * @memberof PilotReportLocalEditFactory
         */
		function updateTotals() {
			var allActiveItems = 0;
			var allWarningItems = 0;
			
			var sectionCount = this.Sections.length;
			for (var i = 0; i < sectionCount; i++) {
				
				var sectionActiveItems = 0;
				var sectionWarningItems = 0;
				
				var itemCount = this.Sections[i].Items.length;
				for (var j = 0; j < itemCount; j++) {
					
					if (this.Sections[i].Items[j].ItemHasValue == true) {
						
						if ((this.Sections[i].Items[j].ItemValue != null) && (this.Sections[i].Items[j].ItemValue != '') ||
							(this.Sections[i].Items[j].DelayMinutes != null && this.Sections[i].Items[j].DelayMinutes > 0))
						{
							allActiveItems++;
							sectionActiveItems++;
						}
						else
						{
							allWarningItems++;
							sectionWarningItems++;
						}
					}
					
				}

				this.Sections[i].ActiveItems = sectionActiveItems;
				this.Sections[i].WarningItems = sectionWarningItems;
			}
			
			this.ActiveItems = allActiveItems;
			this.WarningItems = allWarningItems;
			
			this.GroundServicesSectionHasValue = false;
			// if(this.ArrivalGroundServices){
			// 	for (var i = 0; i < this.ArrivalGroundServices.length; i++) {
			// 		if (this.ArrivalGroundServices[i].Used) {
			// 			this.GroundServicesSectionHasValue = true;
			// 		}
			// 	}
			// }
			if(this.DepartureGroundServices){
				for (var i = 0; i < this.DepartureGroundServices.length; i++) {
					if (this.DepartureGroundServices[i].Used) {
						this.GroundServicesSectionHasValue = true;
					}
				}
			}

			//Check if the report is valid:
			this.IsValid = true; 

			//check valid ACU Provision
			this.ACUProvision.isValid = true;
			if (
				((this.ACUProvision.isRequired && this.ACUProvision.value == null)
				|| 
				(this.ACUProvision.isRequired && this.ACUProvision.value == 'Delayed' && (this.ACUProvision.delayMinutes == null || this.ACUProvision.delayMinutes == 0)))) {
				this.IsValid = false;
				this.ACUProvision.isValid = false;  
			}

			//check valid Autoland Unsatisfactory
			if (this.AutolandUnsatisfactory && !this.AutolandWorkOrderNoIsValid ) {
				this.IsValid = false;
			}

			//check valid form
			if (!this.NothingToReport 
				&& ((this.ActiveItems == 0 && !this.ACUProvision.isRequired) || this.WarningItems > 0) ) {
				this.IsValid = false;
			}
		}
        
        /**
         * Save the Pilot Report
         * @memberof PilotReportLocalEditFactory
         */
		function saveReport() {
			// update the LastUpdated field
			this.LastUpdated = new Date();

			// get the reports array from storage
			var allReports = getPilotReportsFromStorage();
			if (allReports == null)
				allReports = [];
			
			// find the current report from the array (if present)
			var arrayLength = allReports.length;
			var reportIndex = -1;
			for (var i = 0; i < arrayLength; i++) {
				if (allReports[i].ReportGuid == this.ReportGuid) {
					reportIndex = i;
					break;
				}
			}

			// add or update a copy of the current report
			if (reportIndex >= 0)
				allReports[reportIndex] = this;
			else
				allReports.push(this);
			
			// save
			setPilotReportsToStorage(allReports);
		}
    
        /**
         * Save the Report As Temp
         * @memberof PilotReportLocalEditFactory
         */
		function saveReportAsTemp() {

			// update the LastUpdated field
			this.LastUpdated = new Date();

			// save as temp
			localStorageMD5Service.remove('pilotReportLocalEdit_TEMP');
			localStorageMD5Service.set('pilotReportLocalEdit_TEMP', this);
		
		}

		//Factory Functions
																														
	
        /**
         * Extend Object from the default local Pilot Report Object
         * @memberof PilotReportLocalEditFactory
         * @param {Object} obj  a PilotReportLocalEdit
         * @returns {Object} PilotReportLocalEdit
         */
	   function fromObject( obj ) {
				 return GenericService.fromObject(obj,objCallback); 
	   }

	   function fromObjectList( objList ) {
				return GenericService.fromObjectList(objList,objCallback);
	   }
    
        /**
         * Get Pilot Reports from storage
         * @memberof PilotReportLocalEditFactory
         * @returns {Array} PilotReports
         */
	    function getPilotReportsFromStorage(){
				 return GenericService.list(objType,objCallback);
	    }

        /**
         * Get Pilot Reports from storage
         * @memberof PilotReportLocalEditFactory
         * @returns {Array} PilotReports
         */
	   function setPilotReportsToStorage(pilotReportLocalEdits){
				GenericService.saveAll(pilotReportLocalEdits,objType,objCallback);
	    }

        /**
         * Delete Pilot Temporary Report from storage
         * @memberof PilotReportLocalEditFactory
         */
        function deleteTempReport() {
            localStorageMD5Service.remove('pilotReportLocalEdit_TEMP');
        }
    
        /**
         * Delete Selected repport
         * @memberof PilotReportLocalEditFactory
         * @param {string} reportGuid The report's Identifier
         */																												 
        function deleteReport(reportGuid){
            var allReports = getPilotReportsFromStorage();
            if (allReports == null)
                return false; 

            var updatedReports = [];
            var arrayLength = allReports.length;
            var reportIndex = -1;
            for (var i = 0; i < arrayLength; i++) {
                if (allReports[i].ReportGuid == reportGuid) {
                    reportIndex = i;
                    // break;
                }
                else{
                    updatedReports.push(allReports[i]); // copy report in new array
                }
            }

            if (reportIndex = -1){
                setPilotReportsToStorage(updatedReports);
            }
        }
    
        /**
         * Get the Pilot repport of this flight
         * @memberof PilotReportLocalEditFactory
         * @param {number} flightId A flight Id
         * @return {Object} report 
         */
        function getPilotReportLocalEditFromTemp() {
			var pilotReportLocalEdit = localStorageMD5Service.get('pilotReportLocalEdit_TEMP');
			pilotReportLocalEdit = checkForNewGroundServices(pilotReportLocalEdit);
            return fromObject(pilotReportLocalEdit);
        }	

        /**
         * Get the Pilot repport of this flight
         * @memberof PilotReportLocalEditFactory
         * @param {number} flightId A flight Id
         * @return {Object} report 
         */
        function getPilotReportLocalEditForFlight(flightId){
            var pilotReportLocalEdits = getPilotReportsFromStorage();
            if (pilotReportLocalEdits == null)
                return null;

            var result = null;

            var arrayLength = pilotReportLocalEdits.length;
            for (var i = 0; i < arrayLength; i++) {
                            if (pilotReportLocalEdits[i].FlightId == flightId)
                {
                    result = pilotReportLocalEdits[i];
                    break;
                }
            }
			result = checkForNewGroundServices(result);
            return result;
        }
        /**
         * Get the Pilot repport
         * @memberof PilotReportLocalEditFactory
         * @param {string} reportGuid A report Id
         * @return {Object} report 
         */
        function getPilotReportLocalEdit(reportGuid){
            var pilotReportLocalEdits = getPilotReportsFromStorage();
            if (pilotReportLocalEdits == null)
                return null;

            var result = null;

            var arrayLength = pilotReportLocalEdits.length;
            for (var i = 0; i < arrayLength; i++) {
                if (pilotReportLocalEdits[i].ReportGuid == reportGuid)
                {
                    result = pilotReportLocalEdits[i];
                    break;
                }
			}
			result = checkForNewGroundServices(result);

            return result;
		}
		
		/**
         * add any new ground services from storage to the existing report
         * @memberof PilotReportLocalEditFactory
		 * @param {Object} report
         * @return {Object} report 
         */
		function checkForNewGroundServices(report) {
			if (report == null)
				return report;
			
			var depStorageGroundServices =  GroundServicesFactory.getGroundServicesByStation(report.Departure);
			//var arrStorageGroundServices =  GroundServicesFactory.getGroundServicesByStation(report.Arrival);
			for (var i = 0; i < depStorageGroundServices.length; i++) {
				var found = false;
				for (var j = 0; j < report.DepartureGroundServices.length; j++){
					if (depStorageGroundServices[i].ServiceType === report.DepartureGroundServices[j].ServiceType){
						//this ground service is available according to the localstorage but its not in the report
						found = true;
						break;
					}
				}
				if (!found){
					report.DepartureGroundServices.push(depStorageGroundServices[i]);
				}
			}
			// for (var i = 0; i < arrStorageGroundServices.length; i++) {
			// 	var found = false;
			// 	for (var j = 0; j < report.ArrivalGroundServices.length; j++){
			// 		if (arrStorageGroundServices[i].ServiceType === report.ArrivalGroundServices[j].ServiceType){
			// 			//this ground service is available according to the localstorage but its not in the report
			// 			found = true;
			// 			break;
			// 		}
			// 	}
			// 	if (!found){
			// 		report.ArrivalGroundServices.push(arrStorageGroundServices[i]);
			// 	}
			// }
			return report;
		}

        /**
         * Get the number of reports that need to be synched
         * @memberof PilotReportLocalEditFactory
         * @return {number} result A Pilot Report
         */
		function getPilotReportLocalEditCountThatNeedToBeSynched(){
            var pilotReportLocalEdits = getPilotReportsFromStorage();
            if (pilotReportLocalEdits == null)
                return 0;

            var result = 0;

            var arrayLength = pilotReportLocalEdits.length;
            for (var i = 0; i < arrayLength; i++) {
                if (pilotReportLocalEdits[i].Status === 'completed')
                {
                    result++;
                }
            }
		
		return result;
	}

	function getPilotReportLocalEditThatNeedToBeSynched(){
		var result = new Array;
		
		var pilotReportLocalEdits = getPilotReportsFromStorage();
		if (pilotReportLocalEdits == null)
			return result;
		
		var arrayLength = pilotReportLocalEdits.length;
		for (var i = 0; i < arrayLength; i++) {
			if (pilotReportLocalEdits[i].Status === 'completed')
			{
				result.push(pilotReportLocalEdits[i]);
			}
		}
		
		return result;
	}
	
    
    /**
     * Gonstructor for a new Pilot Report
     * @memberof PilotReportLocalEditFactory
     * @return {array} result 
     */
	function getNewReport(){
		return new PilotReportLocalEdit();
	}
	
    /**
     * Mark selected report As Synched
     * @memberof PilotReportLocalEditFactory
     * @param {string} reportGuid The report Guid
     * @return {boolean} isSuccess 
     */    
	function markReportAsSynched(reportGuid){
		
		var report = getPilotReportLocalEdit(reportGuid);
		if (report == null)
			return false;

		report.Status = 'synched';
		report.saveReport();

		return true;
	}

    /**
     * Save  Selected Pilot repport
     * @memberof PilotReportLocalEditFactory
     * @param {Object} report A Pilot Report
     */		
    function setPilotReportToStorage(report){
		var allReports = getPilotReportsFromStorage();
		if (allReports == null)
			return false; // cannot delete a report, if none exist
			
		// find the current report from the array (if present)
		var updatedReports = [];
		var arrayLength = allReports.length;
		var reportIndex = -1;
		for (var i = 0; i < arrayLength; i++) {
			if (allReports[i].ReportGuid == report.ReportGuid) {
				updatedReports.push(report);
								reportIndex=i;
			}
			else{
				updatedReports.push(allReports[i]); // copy report in new array
			}
		}
		
		if (reportIndex != -1){
			setPilotReportsToStorage(updatedReports);
		}
	}

	   /**
         * Get flight ids with pending reports 
         * @memberof PilotReportLocalEditFactory
         * @return [long] List of flight ids 
         */
		function getFlightIdsWithPendingReports() {
			var pilotReportLocalEdits = getPilotReportsFromStorage();
			var flightIds = [];
			if (pilotReportLocalEdits != null)
			{
				var now = moment();
				//var now = moment('2016-06-14') //For debug;
				for (var i = 0; i < pilotReportLocalEdits.length; i++) {
					var flightDate = moment(pilotReportLocalEdits[i].FlightDate);
					if (pilotReportLocalEdits[i].Status !== 'stored' && now.diff(flightDate, 'days') < 5) {
						flightIds.push(pilotReportLocalEdits[i].FlightId);
					}
				}
			}
			return flightIds;
		}

	return service;
}



 
 })();   